import { BarChart } from './BarChart.js';

export interface EpisodeBar {
  key: string;
  kind: 'run_up' | 'drawdown';
  /** A fraction (0.12 = 12 %); drawdowns are negative. */
  pct: number;
  label: string;
  current?: boolean;
}

interface EpisodeBarsProps {
  episodes: readonly EpisodeBar[];
  title: string;
  height?: number;
  /** Every bar grows upward by its size, told apart by colour only (TradingView's "Alternating growth and decline"). */
  magnitude?: boolean;
}

/** The screen-reader summary: how many run-ups and drawdowns. */
export function episodeSummary(episodes: readonly EpisodeBar[]): string {
  const runUps = episodes.filter((e) => e.kind === 'run_up').length;
  return `${runUps} run-ups, ${episodes.length - runUps} drawdowns`;
}

/**
 * The alternating run-ups and drawdowns of an equity curve: run-ups up (gain), drawdowns down (loss) — or every bar up
 * with `magnitude` — height = the episode's percentage, the current episode outlined.
 */
export function EpisodeBars({ episodes, title, height = 180, magnitude = false }: EpisodeBarsProps) {
  return (
    <BarChart
      data={episodes.map((e) => ({
        label: e.label,
        pct: e.kind === 'drawdown' && !magnitude ? -Math.abs(e.pct) * 100 : Math.abs(e.pct) * 100,
        drawdown: e.kind === 'drawdown',
        current: e.current === true,
      }))}
      xKey="label"
      series={[{ key: 'pct', label: 'Change' }]}
      barTone={(row) => (row.drawdown ? 'danger' : 'success')}
      highlight={(row) => row.current}
      formatValue={(value) => `${value.toFixed(1)}%`}
      formatCategory={() => ''}
      title={title}
      summary={episodeSummary(episodes)}
      height={height}
    />
  );
}
